import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "../../../../api/axios";
import { CustomerOperations, OperationEvent, OperationsFilter } from "./types";

export const CUSTOMER_OPERATIONS_PAGE_SIZE = 20;

// One list for live and finished operations: the backend builds each row from the
// operation event log of whichever robotics system the location runs (VLC or LogiCS).
export const useCustomerOperations = (locationId: number, page: number, filter: OperationsFilter, periodDays: number) => {
  return useQuery({
    queryKey: ["customerOperations", locationId, page, filter, periodDays],
    queryFn: async () => {
      const response = await api.get<CustomerOperations>(`/customeroperations/location/${locationId}`, {
        params: { page, pageSize: CUSTOMER_OPERATIONS_PAGE_SIZE, filter, periodDays },
      });
      return response.data;
    },
    placeholderData: keepPreviousData,
    refetchInterval: 15000,
  });
};

// Steps of one flow, loaded only when its row is expanded. Keyed on the row's last activity, so the
// list's own polling triggers a refetch when the flow gets a new step and nothing is polled otherwise.
export const useFlowEvents = (locationId: number, flowId: string, lastActivityAt: string | null) => {
  return useQuery({
    queryKey: ["customerOperationFlow", locationId, flowId, lastActivityAt],
    queryFn: async () => {
      const response = await api.get<OperationEvent[]>(`/customeroperations/location/${locationId}/flows/${flowId}`);
      return response.data;
    },
    placeholderData: keepPreviousData,
    staleTime: Infinity,
  });
};
